export enum LSKey {
  JWT = 'jwt',
  USER_ID = 'userId',
  CURRENT_WORKSPACE_ID = 'currentWorkspaceId'
}